import { render, staticRenderFns } from "./SendRecordTab.vue?vue&type=template&id=5d403aca&scoped=true"
import script from "./SendRecordTab.vue?vue&type=script&lang=js"
export * from "./SendRecordTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d403aca",
  null
  
)

export default component.exports